"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import { motion } from "framer-motion";
import { policyData } from "@/data/PolicyData";
import { cn } from "@/lib/utils/utils";
const PrivacyPolicyView = () => {
  const $ = _c(20);
  const [activeId, setActiveId] = useState(policyData[0].id);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionSubHeading subtitle="Our Commitment" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-2">{t0}<SectionTitle as="h1" title={<>Privacy Policy {t1}{" "}<span className="text-primary">{"& Data Safety"}</span></>} className="font-black leading-[1.1]" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-xs font-bold uppercase tracking-[0.3em] text-black opacity-30">Contents</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== activeId) {
    t4 = policyData.map(item => {
      const isActive = activeId === item.id;
      return <li key={item.id}><a href={`#${item.id}`} onClick={() => setActiveId(item.id)} className={cn("group flex items-center gap-3 text-sm font-bold uppercase tracking-wider transition-all duration-300", isActive ? "text-primary" : "text-muted-foreground hover:text-black")}><span className={cn("h-px bg-primary transition-all duration-500", isActive ? "w-10" : "w-0 group-hover:w-8")} />{item.title}</a></li>;
    });
    $[4] = activeId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <aside className="hidden lg:block w-1/4"><nav className="sticky top-32 space-y-6">{t3}<ul className="space-y-4">{t4}</ul></nav></aside>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activeId) {
    t6 = policyData.map(section => <motion.section key={section.id} id={section.id} initial={{
      opacity: 0,
      x: 20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: "-10%"
    }} transition={{
      duration: 2,
      ease: [0.16, 1, 0.3, 1]
    }} className="group pt-12 md:pt-20 border-b border-black/5 last:border-none"><div className="flex flex-col md:flex-row gap-2 lg:gap-24"><div className="md:w-1/4"><span className={cn("block text-4xl lg:text-7xl font-black transition-colors duration-700", activeId === section.id ? "text-primary/40" : "text-black/5")}>{" "}{section.number}</span><h3 className="mt-4 text-sm font-black uppercase tracking-widest text-primary">{section.title}</h3></div><div className="md:w-3/4 space-y-6"><div className="prose prose-lg max-w-none text-accent-foreground leading-relaxed">{section.description}</div></div></div></motion.section>);
    $[8] = activeId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="flex-1">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="flex flex-col lg:flex-row lg:gap-16 lg:mt-6">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t10;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      y: 30
    };
    t10 = {
      opacity: 1,
      y: 0
    };
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <motion.div initial={t9} whileInView={t10} className="md:mt-24 mt-12 p-12 rounded-2xl bg-black text-white flex flex-col md:flex-row items-center justify-between gap-8"><div className="space-y-3 text-center md:text-left"><h2 className="text-3xl font-black uppercase tracking-tighter">Questions about <span className="text-primary">Privacy?</span></h2><p className="text-white/60 max-w-md">Our Data Protection Officer is available to answer any questions regarding your information.</p></div><a href="mailto:hi@octarnal.com" className="flex h-14 w-full md:w-auto items-center justify-center bg-primary px-10 text-sm font-bold uppercase tracking-widest text-black transition-transform hover:scale-105 active:scale-95">Email Us</a></motion.div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t8) {
    t12 = <section className="lg:py-16 py-8"><Container className="px-4 lg:px-10">{t2}{t8}{t11}</Container></section>;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default PrivacyPolicyView;